import { IArticleResponse, ICustomerService, ISearchResult } from "./ICustomerService";
import { customerService, getArticle, searchArticle } from '../../../tscapi/service/customer.service';
import { ICustomerServiceApi } from "./ICustomerServiceApi";

export class CustomerServiceApiImpl implements ICustomerServiceApi {
  public async getCustomerService(): Promise<ICustomerService> {
    const response = await customerService();
    return response.data;
  }

  public async getArticle(articleName: string): Promise<IArticleResponse> {
    const response = await getArticle(articleName);
    return response.data;
  }

  public async searchArticle(searchTerm: string): Promise<ISearchResult[]> {
    try {
      const response = await searchArticle(searchTerm);
      return response.data;
    } catch (e) {
      return [];
    }
  }
} 